var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.name ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Scenario')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "float-right px-4 hidden-xs-only"
  }, [_c('v-img', {
    attrs: {
      "width": _vm.$size() * 4,
      "height": _vm.$size(),
      "contain": "",
      "src": _vm.icon
    }
  })], 1), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.name, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.name))])]), _c('div', {
    staticClass: "px-4 hidden-sm-and-up"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.icon
    }
  })], 1), _c('div', {
    staticClass: "pb-4"
  }), _vm.category != 5 ? _c('v-list-item', {
    attrs: {
      "to": "/questlibrary/".concat(_vm.id)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Quests')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1) : _c('v-list-item', {
    attrs: {
      "to": "/title/".concat(_vm.id - 5000)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), !_vm.scenarios.length ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Scenario')
    }
  })], 1) : _vm._e(), _vm._l(_vm.scenarios, function (scenario) {
    return [_c('v-divider'), _c('Scenario', {
      attrs: {
        "id": scenario.m_AdvID
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }